import React, { useState } from 'react'
import { Card } from 'primereact/card';
import { Dropdown } from "primereact/dropdown";
import { Calendar } from 'primereact/calendar';
import { useTranslation } from "react-i18next";
import { useReactToPrint } from 'react-to-print';
import FilterDropdown, { isCustomDatePeriod } from '../../../Components/DateRange';
import { CustomerSearchPicker } from '../../../Components/CustomerSearchField';
import {
    TreeSelectLabelTooltip,
    getProductInfoPayload,
    renderItemInfoIcon,
    renderProductDropdownItem,
} from '../../../Components/TreeSelectLabelHelpers';

export const ActionBar = ({
    selectedType, setSelectedType, dropdownItems, selectedOption,
    summaryOptions, setSelectedOption, selectedCustomer, filteredCustomer, searchCustomers, periods, period, setDates, setPeriod,
    setSelectedCustomer, dates, state, setState, placeholder, summaryOption, reactToPrintContent, onClick, setCleared, showCustomDate, setShowCustomDate, customerSearchLoading }) => {

    const { t } = useTranslation("common");
    const handlePrint = useReactToPrint({
        content: reactToPrintContent
    });
    const [customerResultsOpen, setCustomerResultsOpen] = useState(false);
    const customerQuery = typeof selectedCustomer === "string" ? selectedCustomer : (selectedCustomer?.name || "");

    return (
        <div>
            <TreeSelectLabelTooltip />
            <Card id="filters-card" style={{ marginBottom: "3rem" }}>
                <div className='grid report-card-content'>
                    <div className='col-10'>
                        <div className="p-grid p-fluid main-div">
                            <>
                                {
                                    summaryOption === true &&
                                    <div className="p-col-12 p-md-3 filters" >
                                        <div className="p-inputgroup ">
                                            <Dropdown
                                                value={selectedType}
                                                onChange={(e) => { setSelectedType(e.value) }}
                                                options={dropdownItems}
                                                optionLabel="name"
                                                className="w-full activity-dropdown report-plan-customer-dropdown"
                                                id='report-plan-customer-dropdown' />
                                        </div>
                                    </div>
                                }
                                <div className="p-col-12 p-md-3 filters">
                                    {selectedType.code === "plan" ?
                                        <div className="p-inputgroup" >
                                            <Dropdown
                                                value={selectedOption}
                                                options={summaryOptions}
                                                optionLabel="name"
                                                placeholder={placeholder}
                                                filter
                                                onChange={(e) => setSelectedOption(e.value)}
                                                className="w-full custom-dropdown"
                                                itemTemplate={renderProductDropdownItem}
                                                valueTemplate={(option) => (
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        {option ? (
                                                            <>
                                                                <span className="tree-select-node-label" style={{ flex: 1, minWidth: 0 }}>
                                                                    {renderItemInfoIcon(getProductInfoPayload(option))}
                                                                    <span className="tree-select-node-text" style={{ fontSize: '14px' }}>
                                                                        {option.name}
                                                                    </span>
                                                                </span>
                                                                <div>
                                                                    <button
                                                                        className="p-dropdown-clear-icon p-link"
                                                                        onClick={() => setSelectedOption(null)}
                                                                    >
                                                                        <span className="pi pi-times"></span>
                                                                    </button>
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <div style={{ fontSize: '14px', color: '#495057' }}>
                                                                {selectedOption ? selectedOption.name : t(t("summary_reports.choose_product"))}</div>
                                                        )}
                                                    </div>
                                                )}
                                            />

                                        </div> :
                                        <div style={{ width: "15rem" }}>
                                            <CustomerSearchPicker
                                                id="report_customer_search"
                                                placeholder={t("summary_reports.search_by_customer")}
                                                value={customerQuery}
                                                suggestions={filteredCustomer}
                                                open={customerResultsOpen}
                                                loading={Boolean(customerSearchLoading) && customerResultsOpen}
                                                emptyLabel={t("common.no_data")}
                                                onChange={(value) => {
                                                    setCustomerResultsOpen(false);
                                                    setSelectedCustomer(value);
                                                    if (!value) {
                                                        setState((prev) => ({ ...prev, selectedCustomer: null }));
                                                    }
                                                }}
                                                onSearch={() => {
                                                    const query = customerQuery.trim();
                                                    if (!query) return;
                                                    setCustomerResultsOpen(true);
                                                    searchCustomers({ query });
                                                }}
                                                onClear={() => {
                                                    setCustomerResultsOpen(false);
                                                    setSelectedCustomer(null);
                                                    setState((prev) => ({ ...prev, selectedCustomer: null }));
                                                }}
                                                onClose={() => setCustomerResultsOpen(false)}
                                                onSelect={(customer) => {
                                                    setSelectedCustomer(customer);
                                                    setState((prev) => ({ ...prev, selectedCustomer: customer }));
                                                    setCustomerResultsOpen(false);
                                                }}
                                            />
                                        </div>
                                    }
                                </div>
                                
                                <FilterDropdown
                                    value={period}
                                    options={periods}
                                    onChange={(e) => {
                                        setPeriod(e.value);
                                        if (isCustomDatePeriod(e.value)) {
                                            setShowCustomDate?.(true);
                                        } else {
                                            setDates(null);
                                            setShowCustomDate?.(false);
                                        }
                                    }}
                                    optionLabel="name"
                                    id="time"
                                    containerStyle={{ width: "12.5rem" }}
                                />
                                {showCustomDate && <div className="p-col-12 p-md-4 input-div" style={{ width: "18rem" }}>
                                    <div className='report_calender'>
                                        <Calendar className="p-datepicker-header report-calender datepicker"
                                            id='report-calender'
                                            value={dates}
                                            showIcon
                                            showButtonBar
                                            dateFormat="dd M yy"
                                            maxDate={new Date()}
                                            onChange={(e) => {
                                                setDates(e.value)
                                            }} selectionMode="range"
                                            readOnlyInput
                                            placeholder={t("report.choose_date")}
                                            onClearButtonClick={() => {
                                                setDates(null);
                                                setShowCustomDate?.(false);
                                                setCleared?.(true);
                                            }}
                                        />
                                    </div>
                                </div>}
                            </>
                        </div >
                    </div>
                    <div className='col-2'>
                        <div className="export-content" >
                            <div>
                                <span className='export-text' onClick={() => { handlePrint(); onClick(); }}>
                                    {t("summary_reports.export")}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </Card>
        </div>
    )
}
